import { createContext } from "react";
var ServerLocationContext = createContext(void 0);
export {
  ServerLocationContext
};
//# sourceMappingURL=serverLocationContext.js.map
